import { BootstrapOptions, Component, EventEmitter, Inject, Input, LOCALE_ID, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message, SelectItem, ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { TimePickerQuestion } from 'src/app/misc/component/dynamic-form/question-timepicker';
import { MultiSelectQuestion } from 'src/app/misc/component/dynamic-form/question-multiselect';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';

import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { SurveyAssessment } from 'src/app/misc/enums/survey-assessment.enum';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { functionLink } from 'src/app/misc/component/dynamic-form/question-functionLink';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';


@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  messages: Message[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.surveyActionCall({ id: this.operationSurvey._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.surveyActionCall({ id: this.operationSurvey._id, action: 'Delete' })
      }
    }
  ];
  @Input() createSurveyFromCourse: any;
  @Input() fromRating: boolean = false;
  @Input() trainingTypeId: string = "";
  @Input() trainingSurveyTypeId: string = '';
  @Input() updateSurvey: any;
  header = this.translate('Polls');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Polls'), link: '/survey' },
  ];
  stats: stat[] = [];

  translator: TranslatorPipe = new TranslatorPipe()
  @Output() newSurvey = new EventEmitter<any>();

  @Output() updateSurveys = new EventEmitter<any>();

  surveys: any[] = [];
  currentSurvey: any;
  types: any[] = [];
  operationSurvey: any;
  statusOptions: string[] = ['Draft', 'Pending', 'Active', 'Closed']
  questions: QuestionBase<string>[] = [];
  allowedTags: string[] = this.permissionService.extractTags('SURVEY_TYPE', 'r')
  allTags: string[] = [];
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  openCreateModal: boolean = false;
  checkboxValue: boolean = false;
  selectedSurveys: any[] = []
  operationType: any;
  templateSelectionList: any[] = [];
  TypeId: string = '';
  clonedSurvey: any = {};
  isCopy: string = 'false';

  // Table search (by survey name)
  surveySearchText: string = '';

  get filteredSurveys(): any[] {
    const list = this.currentSurvey?.surveys ?? [];
    const term = (this.surveySearchText ?? '').trim().toLowerCase();
    if (!term) return list;
    return list.filter((s: any) => ((s?.name ?? '').toString().toLowerCase().includes(term)));
  }

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private messageService: MessageService
  ) { }


  async ngOnChanges(simpleChange: SimpleChanges) {
    await this.fetchData();
    this.createSurveyFromCourse = true;
    if (!!this.updateSurvey && !!this.updateSurvey.surveyId)
      this.surveyActionCall({ id: this.updateSurvey.surveyId, action: 'Update' });
  }

  async fetchData() {
    try {
      let res = await this.dataService.getData(`survey/id/${this.updateSurvey.surveyId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.operationSurvey = res.data;

    } catch (e) {

    }
  }

  ngOnInit() {
    Promise.all([this.getSurveyTypeTags(), this.getSimpleSurveys(), this.getSurveys(), this.getSurveyTypes()]).then(e => {

      this.makequestion();
      this.skelition = false;
    })

    this.activatedRouter.queryParams.subscribe(params => {
      if (params['TypeId']) {
        this.TypeId = params['TypeId'];
      }
    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  async getSurveyTypeTags() {
    try {
      let res = await this.dataService.getData('survey-tags/SURVEY');
      if (res.error) {
        return;
      }
      if (this.allowedTags.includes('MASTER_TAG')) {
        this.allTags = res.data.filter((e: any) => e.tag != 'MASTER_TAG').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      } else {
        this.allTags = res.data.filter((e: any) => this.allowedTags.includes(e.tag)).map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  getStatusArabic(status: string) {
    switch (status) {
      case this.statusOptions[0]:
        return "مسودة";
      case this.statusOptions[1]:
        return "قيد الانتظار";
      case this.statusOptions[2]:
        return "نشط";
      case this.statusOptions[3]:
        return "غير نشط"
      default:
        return "";
    }
  }

  getSurveys = async () => {
    this.surveys = [];
    this.selectedSurveys = [];
    try {
      let res = await this.dataService.getData(`survey-type/categorized/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.surveys = res.data;

      if (this.TypeId) {
        this.currentSurvey = this.surveys.find(e => e._id == this.TypeId);
      }

      if (!this.currentSurvey) {
        this.currentSurvey = this.surveys[0];
        this.TypeId = this.currentSurvey._id;
      } else {
        this.currentSurvey = this.surveys.find(e => e._id == this.currentSurvey._id);
      }
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  getSimpleSurveys = async () => {
    try {
      let res = await this.dataService.getData(`survey/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.templateSelectionList = res.data;
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  createModal() {
    this.isCopy = 'false';
    this.makequestion();
    this.openCreateModal = true;
  }

  changeCurrentSurvey(event: any) {
    this.currentSurvey = event;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { TypeId: this.currentSurvey._id },
      queryParamsHandling: 'merge'
    });
  }

  async getSurveyTypes() {
    try {
      if (this.createSurveyFromCourse) {
        this.allowedTags = (this.fromRating) ? ["TAG_18", "TAG_24"] : ["TAG_1"];
      }
      console.log('ALLOWED TAGS', this.allowedTags);
      let res = await this.dataService.getData(`survey-type/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.types = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  makequestion() {
    let currentType;
    let showAccessType: boolean = true;

    console.log("trainingSurveyTypeId", this.trainingSurveyTypeId)
    if (this.trainingSurveyTypeId) {
      currentType = this.types.find(e => e._id == this.trainingSurveyTypeId);
      showAccessType = false;
    } else {
      currentType = this.types.find(e => e._id == this.currentSurvey?._id);
    }

    console.log("currentType", currentType)


    if (!currentType) {
      return;
    }
    currentType.label = currentType.name;
    let today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setMilliseconds(0)
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'العنوان',
        required: true,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false",

      }),

      new TimePickerQuestion({
        key: 'startDate',
        label: 'تاريخ البدء',
        required: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.createSurveyFromCourse ? "false" : "true",
        touchUI: true,
        value: this.createSurveyFromCourse ? new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0) : null
      }),

      new TimePickerQuestion({
        key: 'endDate',
        label: 'تاريخ الانتهاء',
        required: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.createSurveyFromCourse ? "false" : "true",
        touchUI: true,
        value: this.createSurveyFromCourse ? new Date(today.getFullYear() + 1, today.getMonth(), today.getDate(), 23, 59, 59) : null
      }),

      new TextEditorQuestion({
        key: 'comments',
        label: 'الوصف',
        className: 'col-md-12 col-sm-12 col-12',
        visibility: "true",
      }),

      new DropdownQuestion({
        key: 'type',
        label: 'النوع',
        options: this.types.map(e => {
          e.label = e.name;
          return e;
        }),
        className: 'col-md-12 col-sm-12 col-12',
        required: true,
        visibility: this.isCopy,
        value: currentType,
      }),

      new RadioButtonQuestion({
        key: 'accessType',
        label: 'النوع',
        options: [
          { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
          { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
        ],
        visibility: showAccessType.toString(),
        className: 'col-md-12 col-sm-12 col-12',
        value: 'BY_ACCOUNT'
      }),

      new RadioButtonQuestion({
        key: 'copyType',
        label: this.translate('Copy Settings'),
        options: [
          { label: this.translate('ONLY_QUESTIONS'), icon: 'pi pi-web', value: 'ONLY_QUESTIONS' },
          { label: this.translate('SETTINGS_AND_QUESTIONS'), icon: 'pi pi-account', value: 'SETTINGS_AND_QUESTIONS' },
        ],
        visibility: this.isCopy,
        className: 'col-md-12 col-sm-12 col-12',
        value: 'ONLY_QUESTIONS'
      }),

      new CheckBoxQuestion({
        key: 'anonymous',
        label: 'إخفاء هوية المشارك',
        required: false,
        order: 1,
        className: 'col-md-12 col-sm-12 col-12',
        value: false
      }),
    ];
  }

  openSurveyMenu(menu: any, event: any, survey: any) {
    this.operationSurvey = survey;
    menu.toggle(event);
  }

  openResultsPage(survey: any) {
    this.router.navigate(['/survey/results/', survey._id], {
      queryParams: {
        TypeId: this.TypeId,
        Main: 1
      }
    })
  }

  receiveSurveyData = async ($event: any) => {
    try {
      let data = $event;
      data.testType = SurveyAssessment.SURVEY;
      if (data.startDate.getTime() == data.endDate.getTime() || data.startDate.getTime() > data.endDate.getTime()) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: "Start data should be less than end date" }
        ];
        return;
      }
      if (this.clonedSurvey) {
        if (data.copyType == 'ONLY_QUESTIONS') {
          data.questions = this.clonedSurvey.questions;
        }
        else {
          data.questions = this.clonedSurvey.questions;
          data.externalQuestions = this.clonedSurvey.externalQuestions;
          data.topics = this.clonedSurvey.topics;
          data.settings = this.clonedSurvey.settings;
        }
      }

      data.startDate = new Date(data.startDate);
      data.startDate.setHours(0, 0, 0, 0);
      data.endDate = new Date(data.endDate);
      data.endDate.setHours(23, 59, 59, 999);

      data.startDate = formatDate(data.startDate, "dd-MM-yyyy HH:mm:ss", this.locale);
      data.endDate = formatDate(data.endDate, "dd-MM-yyyy HH:mm:ss", this.locale);

      if (this.createSurveyFromCourse) {
        data.trainingTypeId = this.trainingTypeId;
      }

      console.log("Data", data);

      let res = await this.dataService.postData('survey', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      if (this.createSurveyFromCourse) this.newSurvey.emit(res);
      this.DynamicFormComponent.resetForm();
      this.openCreateModal = false;
      this.isCopy = 'false';
      this.clonedSurvey = {};
      this.ngOnInit()
    } catch (error) {
      console.log(error);
    }
  };

  updateSurveyData = async (event: any) => {
    try {
      let data: any = event;
      if (typeof data.startDate != 'string') {
        data.startDate.setHours(0, 0, 0, 0);
      }
      if (typeof data.endDate != 'string') {
        data.endDate.setHours(23, 59, 59, 999);
      }
      if (typeof data.startDate != 'string' && typeof data.endDate != 'string') {
        if (data.startDate.getTime() == data.endDate.getTime() || data.startDate.getTime() > data.endDate.getTime()) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: "1 Start data should be less than end date" }
          ];
          return;
        }
      } else {
        if (typeof data.startDate === 'string' && !data.startDate.includes('00:00:00')) {
          data.startDate = data.startDate + ' 00:00:00';
        }
        if (typeof data.endDate === 'string' && !data.endDate.includes('23:59:59')) {
          data.endDate = data.endDate + ' 23:59:59';
        }
        if (data.startDate == data.endDate) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: "2 Start data should be less than end date" }
          ];
          return;
        }
      }
      if (typeof data.startDate != 'string') {
        data.startDate = formatDate(data.startDate, "dd-MM-yyyy HH:mm:ss", this.locale);
      }
      if (typeof data.endDate != 'string') {
        data.endDate = formatDate(data.endDate, "dd-MM-yyyy HH:mm:ss", this.locale);
      }
      if (this.updateData) {
        data._id = this.updateData._id;
      }
      if (typeof data.status != 'string') {
        data.status = data.status.label;
      }
      let res = await this.dataService.postData(
        'survey',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      if (this.createSurveyFromCourse) this.updateSurveys.emit(res);
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  markAll() {
    const visible = this.filteredSurveys;
    visible.forEach((s: any) => {
      s.selected = this.checkboxValue;
    });
    if (this.checkboxValue) {
      const map = new Map<string, any>();
      this.selectedSurveys.forEach((s: any) => {
        if (s?._id) map.set(s._id, s);
      });
      visible.forEach((s: any) => {
        if (s?._id) map.set(s._id, cloneDeep(s));
      });
      this.selectedSurveys = Array.from(map.values());
    } else {
      const ids = new Set(visible.map((s: any) => s?._id).filter(Boolean));
      this.selectedSurveys = this.selectedSurveys.filter((s: any) => !ids.has(s?._id));
    }
  }

  selectSurvey(survey: any, value: boolean) {
    survey.selected = value;
    if (survey.selected) {
      if (!this.selectedSurveys.some((s: any) => s?._id === survey?._id)) {
        this.selectedSurveys.push(cloneDeep(survey));
      }
    } else {
      this.selectedSurveys = this.selectedSurveys.filter(e => e._id != survey._id);
    }
  }

  async bulkDelete() {

    try {
      let ids = this.selectedSurveys.map((s: any) => s._id);
      let res = await this.dataService.postData(`survey/bulkdelete`, { 'ids': ids }, 'POST', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  getTransformetdDate(date: string) {
    let dateArr = date.split('-').map(d => Number(d));
    let dateObj = new Date(dateArr[2], dateArr[1] - 1, dateArr[0])
    return new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
  }

  getTransformedDate(dateTime: string): string {
    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);

    let formattedDate = new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
    if (timePart) {
      const [hours, minutes] = timePart.split(':').map(Number);
      const timeObj = new Date(0, 0, 0, hours, minutes);
      const formattedTime = new DatePipe(this.locale).transform(timeObj, 'HH:mm');
      formattedDate += ' ' + formattedTime;
    }
    return formattedDate || '';
  }

  surveyActionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => {
            if ($event.bulk) {
              this.bulkDelete();
            } else {
              this.deleteSurvey($event.id);
            }
          },
        });
        break;
      case 'Update':
        this.updateData = this.operationSurvey;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('Name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),
          new DropdownQuestion({
            key: 'type',
            label: 'النوع',
            options: this.types,
            className: 'col-12',
            required: true,
            visibility: "false",
            value: this.createSurveyFromCourse ? this.updateData?.type : this.types.find(f => f._id == this.updateData.type)
          }),

          new TimePickerQuestion({
            key: 'startDate',
            label: 'تاريخ البدء',
            required: true,
            className: 'col-6',
            visibility: this.createSurveyFromCourse ? "false" : "true",
            value: this.updateData.startDate,
            touchUI: true,
          }),

          new TimePickerQuestion({
            key: 'endDate',
            label: 'تاريخ الانتهاء',
            required: true,
            className: 'col-6',
            visibility: this.createSurveyFromCourse ? "false" : "true",
            value: this.updateData.endDate,
            touchUI: true,

          }),

          new DropdownQuestion({
            key: 'status',
            label: 'الحالة',
            required: true,
            options: this.statusOptions.map(e => { return { label: this.getStatusArabic(e), value: e } }),
            className: 'col-12',
            visibility: "true",
            value: this.updateData.status
          }),

          new TextEditorQuestion({
            key: 'comments',
            label: 'الوصف',
            className: 'col-12',
            visibility: "true",
            value: this.updateData.comments
          }),

          new RadioButtonQuestion({
            key: 'accessType',
            label: 'النوع',
            options: [
              { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
              { label: 'بواسطة رابط', icon: 'pi pi-web', value: 'BY_URL' },
            ],
            visibility: "true",
            className: 'col-12',
            value: this.updateData.accessType
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            className: 'col-md-12 col-sm-12 col-12',
            value: true,
            visibility: "false",

          }),

          new CheckBoxQuestion({
            key: 'anonymous',
            label: 'إخفاء هوية المشارك',
            required: false,
            order: 1,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData.anonymous || false
          }),

          new functionLink({

            label: this.translate('Copy Link'),
            icon: 'pi pi-copy',
            function: () => {
              console.log('Copy Link Function Called');
              const copyText = `${window.location.origin}/sa/survey/attempt/${this.updateData._id}`;
              navigator.clipboard.writeText(copyText).then(() => {
                this.messageService.add({
                  severity: 'success',
                  summary: this.translate('Link copied successfully'),
                });
              }).catch(err => {
                console.error('Failed to copy link: ', err);
                this.messageService.add({
                  severity: 'error',
                  summary: this.translate('Failed to copy link'),
                });
              });
            }

          })
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  getName(name: any) {
    if (!!name) {
      return name?.first + " " + name?.middle + " " + name?.last;
    }
    return "-"
  }

  deleteSurvey = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`survey/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  setCloneQestions(survey: any) {
    this.isCopy = 'true';
    this.makequestion();
    this.openCreateModal = true;
    this.clonedSurvey = survey;
  }

  onDialogClose() {
    this.clonedSurvey = {};
    this.isCopy = 'false';
  }

  async createSurvey() {

    await this.getSurveys();

    await this.getSurveyTypes();

    this.makequestion();
  }
}
